import { colorError } from '@atlas-frontend/design-tokens';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { FC, memo, useCallback, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { CellContext } from '@tanstack/react-table';
import {
  CategoryFormDataType,
  ClassifierFormDataType,
  DeleteFormTableRowButton,
  ROW_UNIQUE_KEY_NAME,
} from '@atlas-frontend/sdk';
import styled from 'styled-components';
import translations from './CategoryFormTableDeleteButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'category-form-table-delete-button'
);
addTranslations(translations);

export type CategoryFormTableDeleteButtonProps = CellContext<
  CategoryFormDataType,
  any
>;

export const CategoryFormTableDeleteButton: FC<CategoryFormTableDeleteButtonProps> =
  memo((props) => {
    const { index } = props.row;
    const { t } = useTranslation();
    const { getValues } = useFormContext<ClassifierFormDataType>();
    const [isForParentCategory, setIsForParentCategory] = useState(false);

    const checkHierarchyParenthood = useCallback(() => {
      const categories = getValues('categories');
      const categoryKey = getValues(
        `categories.${index}.${ROW_UNIQUE_KEY_NAME}`
      );
      setIsForParentCategory(
        categories.some(({ parentKey }) => parentKey === categoryKey)
      );
    }, [index, getValues]);

    const confirm = useMemo(
      () =>
        isForParentCategory
          ? {
              description: (
                <>
                  <DangerText>{t('info-danger')}</DangerText>
                  <br />
                  {t('info')}
                </>
              ),
            }
          : undefined,
      [isForParentCategory, t]
    );

    return (
      <DeleteFormTableRowButton
        context={props}
        confirm={confirm}
        onClick={checkHierarchyParenthood}
      />
    );
  });

const DangerText = styled.strong`
  color: ${colorError};
`;
